module.exports = __webpack_public_path__ + "img/administrative-complex-fire-rescue-headquarters-training-facility-1.bb467992.jpg";